import {
  doc,
  setDoc,
  updateDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";
export const Product_item_details_edit = async (data) => {
  const { uid, price, mrp } = data || {};

  // 1. Validate inputs
  if (!uid?.trim()) return { success: false, error: "Missing uid for update." }; 

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const companyuid = Cookies.get("select_company_uid");

  if (!sessiontoken || sessiontoken === "undefined")
    return { success: false, error: "Session expired. Please relogin." };
  if (!guid || guid === "undefined")
    return { success: false, error: "Login expired. Please relogin." };
  if (!companyuid || companyuid === "undefined")
    return { success: false, error: "Please select company." };

  try {
    const tablename = "products";

    // ✅ Verify parent exists
    const phonebookQuery = query(
      collection(db, tablename),
      where("uid", "==", uid),
      where("companyuid", "==", companyuid),
      where("guid", "==", guid)
    );

    const snapshot = await getDocs(phonebookQuery);

    if (snapshot.empty) {
      return { success: false, error: "Record not found for update." };
    }

    // ✅ Update parent document
    const parentDocRef = doc(db, tablename, uid); 
    // ✅ Update fields subcollection
    const fieldsCollection = collection(parentDocRef, "fields");
    for (const [fieldName, fieldValue] of Object.entries(data)) {
      if (
        !fieldValue ||
        fieldName === "uid"
      ) {
        continue;
      }

      // check if field already exists
      const existingFields = await getDocs(
        query(fieldsCollection, where("fieldName", "==", fieldName))
      );

      if (!existingFields.empty) {
        // update existing field
        for (const fieldDoc of existingFields.docs) {
          await updateDoc(fieldDoc.ref, {
            fieldValue,
            sessiontoken,
          });
        }

      } else {

        const docid = Randomcode(12);
        const savedata = {
          docid,
          uid,
          guid,
          category: "itemdetails",
          sessiontoken,
          fieldName,
          fieldValue,
          date_time: new Date(),
        };
        const fieldDocRef = doc(fieldsCollection, docid);
        await setDoc(fieldDocRef, savedata);
      }
    }

    return { success: true };
  } catch (err) {
    console.error("❌ Error updating document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
